import React from 'react';
import { useSelectedMapFilter } from 'Features/Map/useSelectedMapFilter';
import { Icon, Pane, Strong, SymbolCircleIcon, Text } from 'evergreen-ui';
import { getSuccessColors, getWarningColors, getDangerColors } from 'Features/StationsNew/Datasources/Components/Statuses/utils';
import { useGetMeteocodeByCodeStringQuery } from 'Services/api/meteoCodesApi';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { mapLegend } from './constants';
import { mapCommonMeteocodes, mapMeteocodeDataColors } from './utilts';

const SUCCESS_COLORS = getSuccessColors(0.7);
const WARNING_COLORS = getWarningColors(0.7);
const DANGER_COLORS = getDangerColors(0.7);

export default function MapLegend() {
  const { selectedMapFilter } = useSelectedMapFilter();
  if (selectedMapFilter === 'METEOCODE') return null;
  return (
    <Pane
      zIndex={401}
      position="absolute"
      bottom={0}
      right={0}
      maxWidth={600}
      height="max-content"
      backgroundColor="white"
      boxShadow="-5px 0px 20px -5px rgba(0,0,0,0.25)"
    >
      <Pane
        padding=".5rem"
        backgroundColor="#f3f4f5"
      >
        <Strong>Условные обозначения</Strong>
      </Pane>
      <Pane
        display="grid"
        gap=".2em"
        gridTemplateRows="max-content max-content max-content"
        padding={8}
      >
        {
          selectedMapFilter === 'COMMON_METEOCODES' ? <MapLegendMeteocodes /> : (
            <>
              <MapLegendDatasourceStatus color={SUCCESS_COLORS.MAIN} text={mapLegend[selectedMapFilter].success} />
              {selectedMapFilter === 'DATA_RECEIVED' && (
              <MapLegendDatasourceStatus color={WARNING_COLORS.MAIN} text={mapLegend[selectedMapFilter].warning} />
              )}
              <MapLegendDatasourceStatus color={DANGER_COLORS.MAIN} text={mapLegend[selectedMapFilter].danger} />
              <MapLegendDatasourceStatus color="gray" text={mapLegend[selectedMapFilter].none} />
            </>
          )
        }
      </Pane>
    </Pane>
  );
}

type MapLegendDatasourceStatusProps = {
  color: string
  text?: string
}

function MapLegendDatasourceStatus({ color, text = '' }: MapLegendDatasourceStatusProps) {
  return (
    <Pane
      display="grid"
      gridTemplateColumns="max-content 1fr"
      columnGap=".5rem"
      alignItems="center"
    >
      <Icon
        size={12}
        icon={SymbolCircleIcon}
        color={color}
      />
      <Text>{text}</Text>
    </Pane>
  );
}

function MapLegendMeteocodes() {
  return (
    <Pane>
      {
        mapCommonMeteocodes.map((meteocode, index) => (
          <MapLegendMeteocode
            key={meteocode}
            meteocodeString={meteocode}
            index={index}
          />
        ))
      }
    </Pane>
  );
}

function MapLegendMeteocode({ meteocodeString, index }: { meteocodeString: string, index: number }) {
  const { data: meteocode = {}, isFetching } = useGetMeteocodeByCodeStringQuery(meteocodeString);
  if (isFetching) return <SuspenseSpinner size={30} />;

  return <MapLegendDatasourceStatus text={`[${meteocodeString}] ${meteocode?.name || '-'}`} color={mapMeteocodeDataColors[index]} />;
}
